// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__d881b","log":"ModalInventoryLogs_log__1juPH","date":"ModalInventoryLogs_date__3Vv8N","userName":"ModalInventoryLogs_userName__3Katt"};